import { RcFile } from "antd/es/upload";

import { axios, persistentQueryClient } from "utils";

import { GET_PLATFORM_CONTRACTS_ADMIN, ADMIN_SETTINGS_URL as endpoint } from "consts";

import { PlatformContract } from "models";

export const getSettings = async (): Promise<{ [setting: string]: string }> => axios.get(`${endpoint}`);

export const updateSettings = async (data: { [setting: string]: string }, signal?: AbortSignal) => axios.put(`${endpoint}`, { data }, { signal });

// shapefile settings

export const getAllShapefileSettings = async (data: unknown) => axios.get(`${endpoint}/shapefiles`, { data });

export const getShapefileSettings = async (data: { id: string }) => axios.get(`${endpoint}/shapefiles/${data.id}`, { data });

export const updateShapefileSettings = async (data: { id: string }) => axios.put(`${endpoint}/shapefiles/${data.id}`, { data });

// emission factors

export const getEmissionFactors = async (data: unknown) => axios.get(`${endpoint}/emission-factors`, { data });

export const updateEmissionFactors = async (data: unknown) => axios.put(`${endpoint}/emission-factors`, { data });

// platform terms & conditions

export const getPlatformContracts = async (): Promise<PlatformContract[]> => axios.get(`${endpoint}/platform-contracts`);

const uploadPlatformContract = async (data: { countryCode: string; languageCode: string; file: string | ArrayBuffer | null }): Promise<{ filename: string }> =>
  axios.post(`${endpoint}/platform-contracts`, { data });

export const updatePlatformContract = async (data: { countryCode: string; languageCode: string; file: RcFile }) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.readAsDataURL(data.file);

    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      uploadPlatformContract({
        file: reader.result,
        countryCode: data.countryCode,
        languageCode: data.languageCode,
      }).then((res) => {
        persistentQueryClient.invalidateQueries({ queryKey: [GET_PLATFORM_CONTRACTS_ADMIN] });
        resolve(res);
      });
    };
  });
};
